/*
 * 虎嗅 - 最新资讯（服务端路由）
 */
export async function fetchHuxiuHot() {
  const res = await fetch('/server-api/huxiu')
  if (!res.ok) throw new Error(`HTTP ${res.status}`)
  return res.json()
}
